import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { shadowLg } from '../../../../web/styles/shadows';

const AVATAR_SIZE = 26;
const SIDE_PADDING = THEME.spacing.md;
/** A step below the app's body text: these rows are previews of a message, not the message. */
const PREVIEW_TEXT_SIZE = 13;

export const ticketHoverPopoverStyles = StyleSheet.create({
	anchor: {
		display: 'inline-block',
		maxWidth: '100%',
	},
	popover: {
		width: 380,
		maxWidth: 'calc(100vw - 24px)',
		padding: 0,
		// The popover portals to the body, so the desk's Sora base (inboxStyles.desk) doesn't reach it.
		fontFamily: THEME.typography.fontFamilies.sora,
		borderColor: THEME.colors.border.light,
		boxShadow: shadowLg,
	},
	header: {
		display: 'flex',
		alignItems: 'baseline',
		gap: THEME.spacing.sm,
		padding: `12px ${SIDE_PADDING}px`,
		borderBottom: `1px solid ${THEME.colors.border.light}`,
	},
	headerNumber: {
		flex: 'none',
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.light,
	},
	// Wraps rather than truncates — reading the whole subject the row had to cut is the point — but
	// stays clamped so a runaway subject can't stretch the popover down the screen.
	headerSubject: {
		// @ts-expect-error Aphrodite's types omit WebKit line clamping.
		display: '-webkit-box',
		WebkitLineClamp: 3,
		WebkitBoxOrient: 'vertical',
		overflow: 'hidden',
		fontSize: PREVIEW_TEXT_SIZE,
		fontWeight: THEME.typography.fontWeights.bold,
		lineHeight: 1.4,
		color: THEME.colors.text.main,
		overflowWrap: 'anywhere',
	},
	body: {
		padding: `14px ${SIDE_PADDING}px`,
	},
	sectionLabel: {
		fontSize: 10,
		fontWeight: THEME.typography.fontWeights.bold,
		letterSpacing: '0.07em',
		textTransform: 'uppercase',
		color: THEME.colors.text.light,
		marginBottom: 8,
	},
	senderRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 9,
		marginBottom: 8,
	},
	senderAvatar: {
		width: AVATAR_SIZE,
		height: AVATAR_SIZE,
		flex: 'none',
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.light,
	},
	senderName: {
		flex: 1,
		minWidth: 0,
		fontSize: PREVIEW_TEXT_SIZE,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		...THEME.common.truncate,
	},
	senderYou: {
		fontWeight: THEME.typography.fontWeights.standard,
		color: THEME.colors.text.light,
	},
	senderTime: {
		flex: 'none',
		fontSize: THEME.typography.fontSizes.xxs,
		color: THEME.colors.text.light,
	},
	messageText: {
		// @ts-expect-error Aphrodite's types omit WebKit line clamping.
		display: '-webkit-box',
		WebkitLineClamp: 3,
		WebkitBoxOrient: 'vertical',
		overflow: 'hidden',
		fontSize: PREVIEW_TEXT_SIZE,
		lineHeight: 1.5,
		color: THEME.colors.text.main,
	},
	divider: {
		display: 'flex',
		alignItems: 'center',
		gap: 10,
		margin: '14px 0',
	},
	dividerLine: {
		flex: 1,
		height: 1,
		backgroundColor: THEME.colors.border.light,
	},
	dividerLabel: {
		flex: 'none',
		fontSize: THEME.typography.fontSizes.xxs,
		color: THEME.colors.text.light,
		whiteSpace: 'nowrap',
	},
	state: {
		padding: '18px 0',
		textAlign: 'center',
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
});
